import VueRouter from 'vue-router'

import authRedirect from '../views/authRedirect/index.vue'

import hukeAutoLogin from '../views/hukeViews/autoLogin/index.vue'

import Vue from 'vue'

// import store from '../store'

// const Login = () => import(/* webpackChunkName: "main" */'../views/login.vue');
// /* webpackChunkName: "main" */
// import Login from '../views/login';
// const Stu = () => import('../views/stu.vue');
// import Stu from '../views/stu';
// const Unit = () => import('../views/unit.vue');
// import Unit from '../views/unit';
// const Upload = () => import('../views/upload.vue')
// import Upload from '../views/upload';

// const hukeXManbanRegister = () => import(/* webpackChunkName: "hukexmanbanregister" */'../views/hukeViews/register/index.vue');

// q:这里注释“webpackChunkName”有必要写吗？
// a:有必要，因为这个是用来给webpack打包的时候，给打包出来的文件命名的，如果不写的话，打包出来的文件名就是“0.js”这样的，不利于我们后期维护
// const hukeXManbanRegisterFinish = () => import(/* webpackChunkName: "hukexmanbanregisterfinish" */'../views/hukeViews/register/finish.vue');

// const StuTable = () => import('../components/stuCtt/stuTable.vue');

// const Main = () => import(/* webpackChunkName: "main" */'../views/main/main');
// const Main = () => import(/* webpackChunkName: "main" */'../views/main/main');

import Main from '../views/main/main.vue'

/* webpackChunkName: "main" */

// const ChooseOrg = () => import(/* webpackChunkName: "main" */'../views/chooseOrg/chooseOrg.vue');

/* webpackChunkName: "main" */

// 课卡模块
// const LessonPackge = () => import(/* webpackChunkName: "main" */'../views/lessonPackage/lessonPackage');

/* webpackChunkName: "main" */

// const ListLessonPackage = () => import(/* webpackChunkName: "lessonpackage" */'../views/lessonPackage/list');

/* webpackChunkName: "lessonpackage" */

// const EditLessonPackage = () => import(/* webpackChunkName: "lessonpackage" */'../views/lessonPackage/edit');

/* webpackChunkName: "lessonpackage" */

// 报名列表
// const signUp = () => import(/* webpackChunkName: "main" */'../views/signUp/signUp');

/* webpackChunkName: "main" */

// const listSignup = () => import(/* webpackChunkName: "signuplist" */'../views/signUp/list');

// const signupWrap = () => import(/* webpackChunkName: "signup" */'../views/signUp/layout.vue');

/* webpackChunkName: "signup" */

// const StepSignUp = () => import(/* webpackChunkName: "stepsignup" */'../views/signUp/step.vue');
// const signUpTransferStation = () => import(/* webpackChunkName: "stepsignup" */'../views/signUp/signUpTransferStation.vue');

/* webpackChunkName: "stepsignup" */

// const familyschoolWrap = () => import(/* webpackChunkName: "familyschool" */'../views/familySchool/layout.vue')

// const recruitstudentWrap = () => import(/* webpackChunkName: "recruitstudent" */'../views/recruitStudent/layout.vue')

// 学员信息

// const allStuMsg = () => import(/* webpackChunkName: "allstumsg" */'../views/allStuMsg/allStuMsg');

// const studentManage = () => import(/* webpackChunkName: "studentManage" */"../views/studentManagement/index.vue");

/* webpackChunkName: "allstumsg" */

// 统一导入引导页面
// const importExcelGuide = () => import(/* webpackChunkName: "importExcelGuide" */'../views/importExcel/guide.vue');

// 导入信息页面
// const importExcel = () => import(/* webpackChunkName: "importExcel" */'../views/importExcel/layout.vue');

// // 导入学员信息

// const importStudentExcel = () => import(/* webpackChunkName: "importStudentExcel" */'../views/importStudentExcel/importStudentExcel');

// /* webpackChunkName: "importStudentExcel" */

// //导入报名信息
// const importOrderExcel = () => import(/* webpackChunkName: "importOrderExcel" */'../views/importOrderExcel/importOrderExcel');

// 导入记录

// const importExcelRecord = () => import(/* webpackChunkName: "importExcelRecord" */'../views/importExcelRecord/importExcelRecord.vue');

// 学员搜索

// const stuSearch = () => import(/* webpackChunkName: "stuSearch" */'../views/stuSearch/stuSearch');

/* webpackChunkName: "stuSearch" */

// 课表
// const StuSchedule = () => import(/* webpackChunkName: "stuShedule" */'../views/schedule/schedule.vue');

// 班级管理

// const ClassManagement = () => import(/* webpackChunkName: "classManagement" */'../views/classManagement/classManagement.vue');

// const classListMange = () => import(/* webpackChunkName: "classListManage" */'../views/classTableList/list.vue')
// import classListMange from '../views/classTableList/list';

// const finishClassListMange = () => import(/* webpackChunkName: "finsihClassListManage" */'../views/classTableList/finishList.vue')

// import finishClassListMange from '../views/classTableList/finishList';

// import classDetail from '../views/classDetail/classDetail';
// const classDetail = () =>  import(/* webpackChunkName: "classDetail" */'../views/classDetail/classDetail.vue')

// 管理设置
// const ManageSettings = () => import(/* webpackChunkName: "manageSettings" */'../views/manageSettings/layout.vue');

// 创建课节
// const createLesLoop = () => import(/* webpackChunkName: "createLesLoop" */'../views/createLessonLoop/createLesLoop');

// 老师管理

// const listTeacherManager = () => import(/* webpackChunkName: "teacherManager" */'../views/teacherManage/list');

// 课程管理

// const listCourseManager = () => import(/* webpackChunkName: "courseManager" */'../views/courseManage/list');

// 统计模块

// const statistic = () => import(/* webpackChunkName: "statistic" */'../views/statistic/statistic.vue');

// 财务 统计模块
// const financeLayout = () => import(/* webpackChunkName: "financeLayout" */ '../views/finance/layout.vue');

// 判断是否有客户端，并调起客户端
// const liveClientJudge = () => import(/* webpackChunkName: "liveClient" */'../views/liveClientJudge/liveClientJudge.vue');

// const liveClientApp = () => import(/* webpackChunkName: "liveClient" */'../views/liveClientApp/liveClientApp.vue');
/* webpackChunkName: "liveClientJudge" */

// const refresh = () => import(/* webpackChunkName: "refresh" */'../components/refresh/index.vue');

// console.log(liveClientJudge, StuSchedule);
// const Test = () => import('../views/test/test.vue');
// import Test from '../views/test/test';

// const Test2 = () => import('../views/test2/test2.vue');

// const test27 = () => import('../views/test/test27.vue');

// const taskListMange = () => import(/* webpackChunkName: "finsihClassListManage" */'../views/classTableList/taskList.vue')
// 创建活动
// const newActivity = () => import('../views/referral/newActivity.vue');

// const activitySucceed = () => import('../views/referral/activitySucceed.vue');

// 设置我的名字页面
// const setUserName = () => import('../views/setUserName/setUserName')
import util from '../tools/util.js'

const router = new VueRouter({
  mode: 'hash',  // hash  history
  routes: [
    {
      path: '/',
      // redirect: '/login'
      redirect: (to) => {
        let token = Vue.prototype.$cookies.get('token') || ''

        console.log(token, 'token')
        if (token) {  // 有无token
          let orgid = Vue.prototype.$cookies.get('orgid') || ''
            // let pc_tabs = Vue.prototype.$cookies.get('pc_tabs');
            // pc_tabs = JSON.parse(pc_tabs)

          const roles = Vue.prototype.$cookies.get('roles')

          Vue.prototype.$cookies.set('token', token, -1)

            // this.$lockr.set('lastTimestamp', now);
          if (!orgid) { // 没有选中机构
            return '/chooseorg'
          } else {
            let pc_tabs = Vue.prototype.$cookies.get('pc_tabs')
            console.log(pc_tabs, 'pc_tabs 跳转前1')
            if (!pc_tabs) {
              return '/auth-redirect'
            }
            if (Array.isArray(pc_tabs)) {
              return util.judgeToPageForDredirect(pc_tabs)
            }
            try {
              pc_tabs = JSON.parse(decodeURIComponent(pc_tabs))
            } catch (error) {
              console.log('pc_tabs parse出错了 所有是空数组')
              pc_tabs = []
            }
            console.log(pc_tabs, 'pc_tabs 跳转前2')
            return util.judgeToPageForDredirect(pc_tabs)
              // const org = Vue.prototype.$cookies.get('org') || {}

              // const {
              //   type: org_type
              // } = org || {}

              // const org_type_head_list = [
              //   'headquarters',
              //   'region'
              // ]

              // if (org_type_head_list.includes(org_type)) {
              //   // this.$router.replace({
              //   //   path: '/main/managesettings'
              //   // })

              //   return '/main/managesettings'

              //   // return false
              // }

              // Vue.prototype.$cookies.set('orgid', orgid);

              // const all_not_only_salemans = ['lead', 'admin', 'teacher']

              // if (Array.isArray(roles)) {
              //   if (roles.some((each_role) => all_not_only_salemans.includes(each_role))) {
              //     return '/main/schedule';
              //   }
              //   return '/main/recruitstudent'
              // } else {
              //   return '/auth-redirect'
              // }
          }
        } else {  // 没有 token 直接去登陆页面
          setTimeout(() => {
            // Vue.prototype.$cookies.remove('token');
            Vue.prototype.$cookies.remove('orgid')
            Vue.prototype.$cookies.remove('pc_tabs')
            Vue.prototype.$cookies.remove('org')
            Vue.prototype.$cookies.remove('roles')
          }, 0)
          return '/login'
        }
      }

    },
    {
      path: '/auth-redirect',
      name: 'authRedirect',
      meta: {
        requiresAuth: false
      },
      component: authRedirect
    },
    {
      path: '/huke-login',
      name: 'hukeAutoLogin',
      meta: {
        requiresAuth: false
      },
      component: hukeAutoLogin
    },
    {
      path: '/refresh',
      name: 'Refresh',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "refresh" */'@/components/refresh/index.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "login" */'@/views/login.vue')
    },
    {
      path: '/huke-manban-register',
      name: 'hukeManbanRegister',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "hukexmanbanregister" */'@/views/hukeViews/register/index.vue')
    },
    {
      path: '/huke-manban-register-finish',
      name: 'hukeManbanRegisterFinish',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "hukexmanbanregisterfinish" */'@/views/hukeViews/register/finish.vue')
    },

    // {
    //   path: '/',
    //   redirect: '/login'
    // },
    {
      path: '/chooseorg',
      name: 'chooseOrg',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "chooseOrg" */'@/views/chooseOrg/chooseOrg.vue')
    },
    // {
    //   path: '/setUserName',
    //   name: 'setUserName',
    //   meta: {
    //     requiresAuth: true // 当有这个字段的时候,我们就认为这个路由页面是要有登录权限的
    //   },
    //   component: setUserName
    // },
    {
      path: '/liveclientjudge',
      name: 'liveClientJudge',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "liveClientJudge" */'@/views/liveClientJudge/liveClientJudge.vue')
    },
    {
      path: '/liveclientjapp',
      name: 'liveClientApp',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "liveClientApp" */'@/views/liveClientApp/liveClientApp.vue')
    },
    {
      path: '/main',
      name: 'main',
      meta: {
        requiresAuth: true
      },
      component: Main,
      children: [
        // {
        //   path: '/main/lessonpackage',
        //   name: 'lessonPackge',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: LessonPackge,
        //   children: [
        //     {
        //       path: '/main/listlessonpackage',
        //       name: 'listLessonPackage',
        //       meta: {
        //         requiresAuth: true
        //       },
        //       component: ListLessonPackage,
        //       children: [
        //         {
        //           path: '/main/listlessonpackage/manbandialog',
        //           name: 'mainlistlessonpackagemanbandialog'
        //         }
        //       ]
        //     },
        //     {
        //       path: '/main/editlessonpackage',
        //       name: 'editLessonPackage',
        //       meta: {
        //         requiresAuth: true
        //       },
        //       component: EditLessonPackage
        //     }
        //   ]
        // },
        // {
        //   path: '/main/signup',
        //   name: 'signUp',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: signUp,
        //   children: [

        //   ]
        // },
        {
          path: '/main/huke2manban',
          name: 'huke2Manban',
          meta: {
            autoLogin: true,
            hiddenAside: true,
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "showmanbanfromhuke" */'@/views/hukeViews/showManban/index.vue')
        },
        // {
        //   path: '/main/listsignup',
        //   name: 'listSignup',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: listSignup,
        //   children: [
        //     {
        //       path: '/main/listSignup/manbandialog', ///:random
        //       name: 'mainlistSignupmanbandialog'
        //     }
        //   ]
        // },
        {
          path: '/main/signup',
          name: 'signup',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "signup" */'@/views/signUp/layout.vue'),
          children: [
            {
              path: '/main/signup/manbandialog', // /:random
              name: 'mainsignupmanbandialog'
            }
          ]
        },
        {
          path: '/main/stepsignup',
          name: 'stepSignUp',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "stepsignup" */'@/views/signUp/step.vue'),
          children: [
            {
              path: '/main/stepsignup/manbandialog',
              name: 'mainstepsignupmanbandialog'
            }
          ]
        },
        // 中转站 处理从报名页跳到报名页
        {
          path: '/main/signuptransferstation',
          name: 'signUpTransferStation',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "stepsignup" */'@/views/signUp/signUpTransferStation.vue'),
          children: [
            {
              path: '/main/stepsignup/manbandialog',
              name: 'mainstepsignuptransferstationmanbandialog'
            }
          ]
        },

        {
          path: '/main/familyschool',
          name: 'familyschool',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "familyschool" */'@/views/familySchool/layout.vue'),
          children: [
            {
              path: '/main/familyschool/manbandialog', // /:random
              name: 'mainfamilyschoolmanbandialog'
            }
          ]
        },
        {
          path: '/main/recruitstudent',
          name: 'recruitstudent',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "recruitstudent" */'@/views/recruitStudent/layout.vue'),
          children: [
            {
              path: '/main/recruitstudent/manbandialog', // /:random
              name: 'mainrecruitstudentmanbandialog'
            },
            {
              path: 'activitySucceed',
              name: 'activitySucceed',
              meta: {
                requiresAuth: true
              },
              component: () => import('@/views/referral/activitySucceed.vue')
            },
            {
              path: 'createEditBenefit',
              name: 'createEditBenefit',
              meta: {
                requiresAuth: true
              },
              component: () => import('@/views/benefitGroup/createEditBenefit.vue')
            },
            {
              path: 'benefitGroupDetail',
              name: 'benefitGroupDetail',
              meta: {
                requiresAuth: true
              },
              component: () => import('@/views/benefitGroup/benefitGroupDetail.vue')
            },
            {
              path: 'benefitGroupDashboard',
              name: 'benefitGroupDashboard',
              meta: {
                requiresAuth: true
              },
              component: () => import('@/views/benefitGroup/dashboard/index.vue')
            }
          ]
        },
        // {
        //   path: '/main/crm',
        //   name: 'crm',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: () => import(/* webpackChunkName: "recruitstudent" */'@/views/CRM/layout.vue'),
        //   children: [
        //     {
        //       path: '/main/crm/manbandialog', ///:random
        //       name: 'maincrmmanbandialog'
        //     }
        //   ]
        // },
        {
          path: '/main/recruitstudent/newactivity',
          name: 'newActivity',
          meta: {
            requiresAuth: true
          },
          component: () => import('@/views/referral/newActivity.vue')
        },
        {
          path: '/main/importexcelguide',
          name: 'importExcelGuide',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "importExcelGuide" */'@/views/importExcel/guide.vue')
        },
        {
          path: '/main/importexcel',
          name: 'importExcel',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "importExcel" */'@/views/importExcel/layout.vue')
        },
        // {
        //   path: '/main/importstudentexcel',
        //   name: 'importStudentExcel',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: importStudentExcel
        // },
        // {
        //   path: '/main/importorderexcel',
        //   name: 'importOrderExcel',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: importOrderExcel,

        // },
        {
          path: '/main/importexcelrecord',
          name: 'importExcelRecord',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "importExcelRecord" */'@/views/importExcelRecord/importExcelRecord.vue')
        },
        {
          path: '/main/studentmanage',
          name: 'studentManage',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "studentManage" */'@/views/studentManagement/index.vue'),
          children: [
            {
              path: '/main/studentmanage/manbandialog',
              name: 'mainstudentmanagemanbandialog'
            }
          ]
        },
        // {
        //   path: '/main/stusearch',
        //   name: 'stuSearch',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: stuSearch,
        //   children:[
        //     {
        //       path: '/main/stusearch/manbandialog',
        //       name: 'mainstusearchmanbandialog'
        //     }
        //   ]
        // },
        {
          path: '/main/schedule',
          name: 'stuSchedule',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "stuShedule" */'@/views/schedule/schedule.vue'),
          children: [
            {
              path: '/main/schedule/manbandialog',
              name: 'mainschedulemanbandialog'
            }
          ]
        },
        // {

        //   path: '/main/listteachermanager',
        //   name: 'listTeacherManager',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: listTeacherManager,
        //   children:[
        //     {
        //       path: '/main/listteachermanager/manbandialog',
        //       name: 'mainlistteachermanagermanbandialog'
        //     }
        //   ]
        // },
        // {
        //   path: '/main/listcoursemanager',
        //   name: 'listCourseManager',
        //     meta: {
        //       requiresAuth: true
        //     },
        //   component: listCourseManager,
        //   children:[
        //     {
        //     path: '/main/listcoursemanager/manbandialog',
        //     name: 'mainlistcoursemanagermanbandialog'
        //     }
        //   ]
        // },
        // classmanagement
        {
          path: '/main/classmanagement',
          name: 'classManagement',
          meta: {
            requiresAuth: true
          },
          // 这里不再重定向，二级菜单动态
          // redirect: '/main/classmanagement/list',
          component: () => import(/* webpackChunkName: "classManagement" */'@/views/classManagement/classManagement.vue'),
          children: [
            {
              path: 'list',
              name: 'classListManagement',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "classListManage" */'@/views/classTableList/list.vue')
            },
            {
              path: 'detail/:id',
              name: 'classDetailManagement',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "classDetail" */'@/views/classDetail/classDetail.vue')
            },

            {
              path: 'finish-list',
              name: 'finishClassListManagement',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "finsihClassListManage" */'@/views/classTableList/finishList.vue')
            },
            // 场地管理
            {
              path: 'court_manage',
              name: 'courtSanage',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "courtSanage" */'@/views/courtSanage/courtSanage.vue')
            },
            {
              path: 'course_resource_manage',
              name: 'courseResourceManage',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "banxue" */'@/views/banxue/index.vue')
            },
            {
              path: 'practice_plan_manage',
              name: 'practicePlanManage',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "banxue" */'@/views/banxue/index.vue')
            },
            {
              path: 'course_resource_binds',
              name: 'courseResourceBinds',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "banxue" */'@/views/banxue/index.vue')
            },
            {
              path: 'vocab',
              name: 'courseResourceVocab',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "banxue" */'@/views/banxue/index.vue')
            },
            // 场地预约
            {
              path: 'court_booking',
              name: 'courtBooking',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "courtBooking" */'@/views/courtBooking/courtBooking.vue')
            },
            {
              path: '/main/classmanagement/manbandialog',
              name: 'mainclassmanagementmanbandialog'
            },
            {
              path: 'task-list',
              name: 'taskListManage',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "taskList" */'@/views/classTableList/taskList.vue')
            },
            // 学员分班记录
            {
              path: 'streams_analysis',
              name: 'streamsAnalysis',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "taskList" */'@/views/classTableList/streamsAnalysis.vue')
            },
            // 课程设置
            {
              path: 'course_manage',
              name: 'courseManage',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "taskList" */'@/views/courseManage/list.vue')
            },
            // 教室管理
            {
              path: 'classroom_manage',
              name: 'classroomManage',
              meta: {
                requiresAuth: true
              },
              component: () => import(/* webpackChunkName: "taskList" */'@/views/classRoomAndPointManange/layout.vue')
            }

          ]
        },
        // 管理设置
        {
          path: '/main/managesettings',
          name: 'manageSettings',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "manageSettings" */'@/views/manageSettings/layout.vue'),
          children: [
            {
              path: '/main/managesettings/manbandialog',
              name: 'mainmanagesettingsmanbandialog'
            }
          ]
        },
        // {
        //   path: '/main/createlesloop',
        //   name: 'createLesLoop',
        //   meta: {
        //     requiresAuth: true
        //   },
        //   component: createLesLoop,
        //   children:[
        //     {
        //       path: '/main/createlesloop/manbandialog',
        //       name: 'maincreateleslooprmanbandialog'
        //     }
        //   ]
        // },
        {
          path: '/main/statistic/chatbi',
          name: 'interactionChatBi',
          meta: {
            requiresAuth: true,
            hiddenAside: true
          },
          component: () => import(/* webpackChunkName: "interactionChatBi" */'@/views/statistic/interactionChatBi/index.vue')
        },
        {
          path: '/main/statistic',
          name: 'statistic',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "statistic" */'@/views/statistic/statistic.vue'),
          children: [
            {
              path: '/main/statistic/manbandialog',
              name: 'mainstatisticmanbandialog'
            }
          ]
        },
        {
          path: '/main/query',
          name: 'query',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "query" */'@/views/query/layout.vue'),
          children: [
            // {
            //   path: '/main/statistic/manbandialog',
            //   name: 'mainquerymanbandialog'
            // }
          ]
        },
        {
          path: '/main/salesmanage',
          name: 'salesmanage',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "salesmanage" */'@/views/salesManage/layout.vue'),
          children: [
            {
              path: '/main/salesmanage/manbandialog',
              name: 'mainsalesmanagemanbandialog'
            }
          ]
        },
        // /main/finance
        {
          path: '/main/finance',
          name: 'finance',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "financeLayout" */ '@/views/finance/layout.vue'),
          children: [
            {
              path: '/main/finance/manbandialog',
              name: 'mainfinancemanbandialog'
            }
          ]
        },
        {
          path: '/main/org_group_finance',
          name: 'org_group_finance',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "financeLayout" */ '@/views/finance/orgGroupLayout.vue'),
          children: [
            {
              path: '/main/finance/manbandialog',
              name: 'mainorggroupfinancemanbandialog'
            }
          ]
        }
      ]
    },

    {
      path: '/test',
      name: 'test',
      meta: {
        requiresAuth: true
      },
      component: () => import('@/views/test/test.vue'),
      children: [
        {
          path: 'test1',
          name: 'test1',
          meta: {
            requiresAuth: true
          },
          component: () => import('@/components/stuCtt/stuTable.vue')
        },
        {
          path: 'test2',
          name: 'test2',
          meta: {
            requiresAuth: true
          },
          component: () => import('@/views/test2/test2.vue')
        }
      ]

    },
    {
      path: '/test27',
      name: 'test27',
      meta: {
        requiresAuth: true
      },
      component: () => import('@/views/test/test27.vue')
    },
    {
      path: '/403',
      component: () => import('@/components/specialTreatmentFor403')
    },
    {
      path: '/404',
      component: () => import('@/views/404')
    },
    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404' },
    {
      path: '/province',
      name: 'province',
      component: () => import('@/views/province/index.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.sessionStorage.hasPath = from.path
  next()
  console.log('window.sessionStorage.hasPath', window.sessionStorage.hasPath)
})

export default router
